<template>
  <v-card class="pb-3 height-100 border-white">
    <v-card-title class="back-556C96 justify-center mb-5">
      <h3 class="color-white">
        {{ this.status == "invoice" ? "출고양식 업로드" : "발주양식 업로드" }}
      </h3>
    </v-card-title>
    <v-row class="ma-0 align-center pt-5 pb-5">
      <h4 class="ma-3 pr-3 pl-4">파일명</h4>
      <div class="pr-5 " @click="fileSearch">
        <input
          placeholder="파일명"
          class="width-heigth1"
          :id="status + 'FileUpLoad'"
          accept=".xls,.xlsx,.xlsm"
          type="file"
          @change="fileChange"
        />
        <input
          placeholder="파일명"
          class="border-aaaaaa width-heigth place cursor-pointer"
          disabled
          v-model="filename"
        />
      </div>
      <v-btn
        color="#718FC7"
        width="121"
        height="42"
        class="color-white"
        @click="fileSearch"
        >불러오기</v-btn
      >
    </v-row>
    <v-row class="mr-0 ml-0 mb-5 mt-5 pb-5 pt-5 back-F7FAFF">
      <div class="align-center pb-4 width-100 pl-5">
        양식다운로드
        <v-icon class="pl-1">mdi-cloud-download</v-icon>
      </div>
      <div class="font-size pl-5">
        <h4 v-html="explanation" style="font-weight: 500;"></h4>
      </div>
      <div class="justify-end d-flex pt-3 width-100 pr-5 mr-1">
        <v-btn
          color="#718FC7"
          width="121"
          height="38"
          class="color-white"
          @click="downForm"
          >양식다운로드
        </v-btn>
      </div>
    </v-row>
    <v-row
      color="#3F557D"
      width="185"
      height="53"
      class="ma-0 justify-center pt-5 pb-5"
    >
      <v-btn
        width="140"
        height="38"
        class="color-white mr-3"
        color="#3F557D"
        @click="upload"
        >업로드</v-btn
      >
      <v-btn
        width="140"
        height="38"
        color="#eeeeee"
        @click="
          status == 'order'
            ? $bus.$emit('OrderFormOff')
            : $bus.$emit('InvoiceForm', false)
        "
        >닫기</v-btn
      >
    </v-row>
  </v-card>
</template>

<script>
import FileApi from "@/api/FileService";
import fileDownload from "@/assets/js/file-download.js";
import Commonality from "@/mixin/Commonality";
export default {
  mixins: [Commonality],
  props: ["status"],

  data: function() {
    return {
      filename: "",
      file: "",
      error: "",
    };
  },

  created() {
    this.$bus.$on("fileClear", () => {
      this.fileClear();
    });
  },
  computed: {
    explanation() {
      let text = status == "invoice" ? "일괄출고" : "일괄발주";
      return `${text} 업로드에 대한 동작 방식 안내 사항 양식 기준으로 업로드 해야 합니다. <br>
                    양식과 다른 형태는 업로드 되지 않습니다.<br>
                    확장자 명은 .xlsx 이어야 합니다. (엑셀 통합문서)`;
    },
  },
  methods: {
    fileSearch() {
      if (document.getElementById(`${this.status}FileUpLoad`).value)
        document.getElementById(`${this.status}FileUpLoad`).value = "";
      document.getElementById(`${this.status}FileUpLoad`).click();
    },

    fileChange(e) {
      if (e.target.files.length > 0) {
        this.file = e.target.files[0];
        this.filename = this.file.name;
      }
    },

    async downForm() {
      this.$bus.$emit("loadingStart");
      let data = { constructionId: this.constructionId };
      if (this.status == "order") {
        const res = await FileApi.orderStyleDown(data);
        fileDownload(
          res.data,
          `${this.constructionName.constructionName} 발주양식.xlsx`
        );
      } else if (this.status == "invoice") this.$bus.$emit("orderListShow");
      this.$bus.$emit("loadingEnd");
    },

    upload() {
      if (this.file.length < 1) {
        this.$bus.$emit("dialog", "파일을 등록 후 진행해주세요.");
        return;
      }
      this.status == "order"
        ? this.$bus.$emit("fileSearch", this.file)
        : this.$bus.$emit("invoiceFileSearch", this.file);
    },

    fileClear() {
      this.filename = "";
      this.file = "";
      try {
        if (!document.getElementById(`${this.status}FileUpLoad`).value)
          document.getElementById(`${this.status}FileUpLoad`).value = "";
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>

<style scoped>
.width-heigth {
  width: 242px;
  height: 42px;
}

.font-size {
  font-size: 14px !important;
}

#fileUpLoad {
  visibility: hidden !important;
}

.width-heigth1 {
  width: 0px;
  height: 0px;
}

input {
  padding-left: 15px;
}
</style>
